import React, { useState, useRef, useEffect } from 'react';
import './CompactCollaborationBar.css';
import CollaborationDropdown from './CollaborationDropdown';

const CompactCollaborationBar = ({ 
  connectionStatus, 
  collaborators = [], 
  currentUser,
  onInvite 
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showDropdown]);

  const getStatusInfo = () => {
    switch (connectionStatus) {
      case 'connected':
      return { text: 'Connected', className: 'status-connected', icon: <span className="status-dot status-dot-green"></span> };
      case 'disconnected':
      return { text: 'Disconnected', className: 'status-disconnected', icon: <span className="status-dot status-dot-red"></span> };
      default:
      return { text: 'Unavailable', className: 'status-unavailable', icon: <span className="status-dot status-dot-gray"></span> };
    }
  };

  const status = getStatusInfo();
  const onlineCount = collaborators.filter(c => c.isOnline).length + (connectionStatus === 'connected' ? 1 : 0);

  return (
    <div className="compact-collaboration-bar" ref={dropdownRef}>
      {/* Connection Status Dot Only */}
      <div 
        className={`collab-status-dot ${status.className}`}
        title={status.text}
      >
        <span className="status-icon">{status.icon}</span>
      </div>

      {/* Avatars Only - Max 2 visible */}
      <button 
        className="collab-users-section"
        onClick={() => setShowDropdown(!showDropdown)}
        aria-label="Show collaborators"
      >
        <div className="avatar-stack">
          {/* Current user first */}
          {currentUser && (
            <div 
              key="current-user"
              className="avatar avatar-current" 
              style={{ backgroundColor: currentUser.color || '#6366f1' }}
              title={`${currentUser.username || currentUser.email} (you)`}
            >
              {(currentUser.username || currentUser.email)?.[0]?.toUpperCase()}
            </div>
          )}
          
          {/* Show only 1 other collaborator */}
          {collaborators
            .filter(c => c.isOnline)
            .slice(0, 1)
            .map((collab, index) => (
              <div 
                key={collab.userId}
                className="avatar" 
                style={{ 
                  backgroundColor: collab.color,
                  zIndex: 9 - index
                }}
                title={collab.username || collab.email}
              >
                {(collab.username || collab.email)?.[0]?.toUpperCase()}
              </div>
            ))
          }
          
          {/* Show +X if more than 1 other collaborator */}
          {collaborators.filter(c => c.isOnline).length > 1 && (
            <div key="more-users" className="avatar avatar-more" title={`+${collaborators.filter(c => c.isOnline).length - 1} more`}>
              +{collaborators.filter(c => c.isOnline).length - 1}
            </div>
          )}
        </div>
      </button>

      {/* Dropdown */}
      {showDropdown && (
        <CollaborationDropdown 
          collaborators={collaborators}
          currentUser={currentUser}
          connectionStatus={connectionStatus}
          onClose={() => setShowDropdown(false)}
          onInvite={onInvite}
        />
      )}
    </div>
  );
};

export default CompactCollaborationBar;
